module.exports = __webpack_public_path__ + "static/jakub_tanski-780bed73cd379c49c9f0a376495da8c5.jpg";